/**
 * Opcions del selector «Tipus de document» (`components/forms/DocumentForm.tsx`).
 *
 * Els codis són els oficials dels Mossos (RD 933/2021). Però els clients sincronitzats de
 * Cuentica porten el `tax_id_type` de Cuentica (`nif`, `vat_id`, `passport`, `platform_default`)
 * i n'hi ha d'altes antigues amb `DNI`/`CIF`. No es normalitzen: són el vocabulari de Cuentica i
 * desar-los com a `D` el perdria. El selector mostra el valor desat com una opció més, de manera
 * que es veu i, si no es toca, es desa igual.
 */
export interface DocumentTypeOption {
  value: string
  label: string
}

export const MOSSOS_DOCUMENT_TYPES: DocumentTypeOption[] = [
  { value: 'D', label: 'DNI / NIF / TIE' },
  { value: 'N', label: 'NIE (Permís de residència)' },
  { value: 'P', label: 'Passaport' },
  { value: 'C', label: 'Carnet de Conduir' },
  { value: 'O', label: 'Altre' },
]

const SAVED_TYPE_LABELS: Record<string, string> = {
  nif: 'NIF (Cuentica)',
  vat_id: 'NIF-IVA / VAT (Cuentica)',
  passport: 'Passaport (Cuentica)',
  platform_default: 'Per defecte de la plataforma (Cuentica)',
  DNI: 'DNI',
  NIE: 'NIE',
  CIF: 'CIF',
}

/**
 * Etiqueta d'un tipus de document desat (fitxa i llista de clients): codi dels Mossos o de
 * Cuentica amb la mateixa etiqueta que el selector; un valor desconegut, tal qual; sense
 * valor, «Document».
 */
export function documentTypeLabel(code: string | null | undefined): string {
  if (!code) return 'Document'
  return (
    MOSSOS_DOCUMENT_TYPES.find((option) => option.value === code)?.label ?? SAVED_TYPE_LABELS[code] ?? code
  )
}

/** Les opcions dels Mossos i, al davant, el valor desat si no n'és cap */
export function documentTypeOptions(current: string | null | undefined): DocumentTypeOption[] {
  if (!current || MOSSOS_DOCUMENT_TYPES.some((option) => option.value === current)) {
    return MOSSOS_DOCUMENT_TYPES
  }
  return [{ value: current, label: documentTypeLabel(current) }, ...MOSSOS_DOCUMENT_TYPES]
}
